import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { selectors as apiSelectors } from 'zender-api-client';

import * as appSelectors from '../../../../selectors';
import Stream from './Stream.component';

const StreamContainer = props => <Stream {...props} />;

const mapStateToProps = state => ({
	locale: appSelectors.locale.localeSelector(state),
	config: apiSelectors.config.configSelector(state),
	queryParams: appSelectors.ui.queryParamsSelector(state),
	pathName: appSelectors.router.pathNameSelector(state),
});

const mapDispatchToProps = () => ({});

StreamContainer.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(StreamContainer);



// WEBPACK FOOTER //
// ./src/ui/streams/children/stream/Stream.container.js